import styles from './Destination.module.scss';
import { Destination as DestinationModel } from '../models/destination';

interface DestinationProps {
  destination: DestinationModel;
}

export default function Destination({ destination }: DestinationProps) {
  return (
    <div className={styles['destination']}>
      <div className={styles['destination__primary']}>
        {destination.primary}
      </div>

      {destination.secondary && (
        <div className={styles['destination__secondary']}>
          {destination.secondary}
        </div>
      )}
    </div>
  );
}
